import { render, staticRenderFns } from "./CarouselCards.vue?vue&type=template&id=d192cebc&scoped=true"
import script from "./CarouselCards.vue?vue&type=script&lang=js"
export * from "./CarouselCards.vue?vue&type=script&lang=js"
import style0 from "./CarouselCards.vue?vue&type=style&index=0&id=d192cebc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d192cebc",
  null
  
)

export default component.exports